import { ApiService } from "./api.service";
export default class PreviewTBAService extends ApiService {
  namespace = "reviewToBeApproved";
  DOMAIN = -67;
  name = "Review To Be Paid";
  template = "defaultTemplate";
  Width = 850;
  favicon = "SaveTick";
  constructor() {
    super("ap-batch-items/preview");
  }
}
